import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
var Bubble = function Bubble(_ref) {
  var children = _ref.children,
    tail = _ref.tail,
    className = _ref.className;
  var Tail;
  var tailClassName;
  if (~'leftTop leftBottom rightTop rightBottom'.indexOf(tail)) {
    Tail = require("./assets/tailVertical.svg");
    tailClassName = 'imageVertical';
  } else {
    Tail = require("./assets/tailHorizontal.svg");
    tailClassName = 'imageHorizontal';
  }
  return /*#__PURE__*/React.createElement("div", {
    className: cx('bubble', tail, className, {
      topLeft: !tail && !className
    }),
    "data-t-id": "components-Bubble"
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('content')
  }, children), tail !== 'none' && /*#__PURE__*/React.createElement("div", {
    className: cx('tail')
  }, /*#__PURE__*/React.createElement(Tail, {
    className: cx(tailClassName)
  })));
};
Bubble.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  tail: PropTypes.oneOf(['leftTop', 'leftBottom', 'rightTop', 'rightBottom', 'topLeft', 'topRight', 'topCenter', 'bottomLeft', 'bottomRight', 'bottomCenter', 'none'])
} : {};
export default Bubble;